import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { SidebarToggleInterface } from './types/sidebarToggle';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { FooterComponent } from './footer/footer.component';
import { AuthService } from 'src/app/auth/components/login/services/auth.service';
import { AppAsideComponent } from './app-aside/app-aside.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    AppAsideComponent,
    CommonModule,
    BreadcrumbComponent,
    FooterComponent,
  ],
})
export class LayoutComponent {
  collapsed = false;
  screenWidth = 0;
  authService = inject(AuthService);

  handleToggleCollapseEvent(e: SidebarToggleInterface): void {
    this.collapsed = e.collapsed;
    this.screenWidth = e.screenWidth;
  }

  getBodyClass(): string {
    let styleClass = '';
    if (this.collapsed && this.screenWidth > 1260) {
      styleClass = 'main-content_trimmed';
    } else if (
      this.collapsed &&
      this.screenWidth <= 1260 &&
      this.screenWidth > 0
    ) {
      styleClass = 'main-content_md-screen';
    }
    return styleClass;
  }
}
